module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-mobile-411x93@2x.c1b622fe.webp";